import { Dumbbell, UserCheck, Trophy } from "lucide-react";

function Benefits() {
    const benefits = [
        {
            id: 1,
            title: "Echipamente moderne",
            text: "Aparate bine intretinute si spatiu pregatit pentru antrenamente eficiente.",
            icon: <Dumbbell size={22} strokeWidth={2.2} />
        },
        {
            id: 2,
            title: "Antrenori dedicati",
            text: "Indrumare corecta, suport real si experienta pentru progres constant.",
            icon: <UserCheck size={22} strokeWidth={2.2} />
        },
        {
            id: 3,
            title: "Atmosfera motivanta",
            text: "Un loc in care vii sa muncesti serios, sa evoluezi si sa te simti bine.",
            icon: <Trophy size={22} strokeWidth={2.2} />
        }
    ];

    return (
        <section className="benefits">
            <div className="benefits-container">
                <div className="benefits-header">
                    <p className="benefits-label">De ce Cris Gym</p>
                    <h2 className="benefits-title">Tot ce ai nevoie pentru rezultate reale</h2>
                    <p className="benefits-subtitle">
                        Construim un spatiu in care antrenamentul, disciplina si progresul merg impreuna.
                    </p>
                </div>

                <div className="benefits-grid">
                    {benefits.map((benefit) => (
                        <div key={benefit.id} className="benefit-card">
                            <div className="benefit-icon">
                                {benefit.icon}
                            </div>

                            <h3>{benefit.title}</h3>
                            <p>{benefit.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Benefits;